import * as React from 'react';
import { isNull } from 'utils/utils';
import { IOutstandingCustomerQuotesProperties } from './OutstandingCustomerQuotes.properties';
import configurationSchema from './OutstandingCustomerQuotes.form.json';
import ChartContainer from 'components/common/Charts/Charts.container';
import DoughnutChart from 'components/common/Charts/DoughnutChart';
import { withStyles } from '@material-ui/core/styles';
import styles from './OutstandingCustomerQuotes.styles';
import { IDashboardWidgetOutstandingCustomerQuoteFacade } from 'api/swaggerTypes';

const Hundred = 100;
const FIXED_VALUE = 2;

const OutstandingCustomerQuotesComponent = (props: IOutstandingCustomerQuotesProperties): JSX.Element => {
    const { classes, widgetInfo, modalFormValues = {}, getOutstandingCustomerQuotes, touchFormFields, updateFormField } = props;
    const [filterOpen, setFilterOpen] = React.useState<boolean>(false);
    const [isConfigurationSet, setIsConfigurationSet] = React.useState<boolean>(false);
    const [chartData, setChartData] = React.useState<IDashboardWidgetOutstandingCustomerQuoteFacade[]>([]);
    const [initValues, setInitValues] = React.useState<any>({});
    const [totalOutstanding, setTotalOutstanding] = React.useState<number>(0);
    const [totalCount, setTotalCount] = React.useState<number>(0);

    React.useEffect(
        () => {
            if (widgetInfo && widgetInfo.Configuration) {
                const configuration = JSON.parse(widgetInfo.Configuration);
                setIsConfigurationSet(true);
                fetchSalesHistory(configuration.Entity, configuration.EntityView);
            }
        },
        [widgetInfo]
    );

    const fetchSalesHistory = (wh, entView) => {
        setInitValues({
            Entity: wh,
            EntityView: entView,
        });
        getOutstandingCustomerQuotes({ SalesEntity: wh, EntView: entView })
            .then((res) => {
                const { OutstandingCustomerQuotes } = res;
                const data = OutstandingCustomerQuotes && OutstandingCustomerQuotes.inlineObject;
                setChartData(data.OutstandingQuotes);
                setTotalOutstanding(data.TotalQuotesValueDisplay);
                setTotalCount(data.TotalQuotesCountDisplay);
            }).catch((err) => {
                console.warn(err);
            });

    };

    const validateConfiguration = () => (!isNull(modalFormValues.EntityView) && !isNull(modalFormValues.Entity));

    const handleOkClick = () => {
        if (validateConfiguration()) {
            fetchSalesHistory(modalFormValues.Entity, modalFormValues.EntityView);
            setIsConfigurationSet(true);
            setFilterOpen(false);
        } else {
            touchFormFields('Entity');
            touchFormFields('EntityView');
        }
    };
    const handleCancelClick = () => {
        setFilterOpen(false);
    };

    const customizeTooltip = (arg) => {

        return {
            text: `
            $${arg.point.data.QuoteValueDisplay} - ${(arg.percent * Hundred).toFixed(FIXED_VALUE)}%\n
            (Count: ${arg.point.data.QuoteCountDisplay})`,
        };
    };

    const customizeLabelText = (arg) => {
        return `$${arg.point.data.QuoteValueDisplay}`;
    };
    const onEntityViewChange = () => {
        updateFormField('Entity', '');
    };

    return (<div >
        <ChartContainer
            isConfigurationSet={isConfigurationSet}
            filterOpen={filterOpen}
            title='Outstanding Customer Quotes'
            widgetInfo={widgetInfo}
            modalFormProps={{
                formSchema: configurationSchema,
                initialValues: initValues,
                formValues: modalFormValues,
                fieldExtensions: {
                    EntityView: {
                        onSelectedItemChange: onEntityViewChange,
                        onSelectedValueChange: onEntityViewChange
                    },
                    Entity: {
                        params: { ParentView: modalFormValues.EntityView }
                    },
                }
            }}
            setFilterOpen={setFilterOpen}
            modalOkClick={handleOkClick}
            modalCancelClick={handleCancelClick}
            validateConfiguration={validateConfiguration}
        >
            <DoughnutChart chartData={chartData} config={{
                id: 'OutstandingCustomerQuotes',
                title: 'Outstanding Customer Quotes',
                seriesArgumentField: 'Age',
                seriesValueField: 'QuoteValue',
                customizeTooltip,
                customizeLabelText

            }} />
            <div className={classes.totalContainer}>
                <span>Total outstanding: <b>{`$${totalOutstanding}`}</b></span>
                <span>Total count:<b> {totalCount}</b></span>
            </div>
        </ChartContainer>

    </div >);
};

export default withStyles(styles, { index: 1 })(OutstandingCustomerQuotesComponent);
